var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuAccounts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 21V21.75H10.75V21H10ZM8.4717 9.95094L8.07547 9.31415L8.4717 9.95094ZM5.4717 11.8176L5.07547 11.1808L5.4717 11.8176ZM5.86792 12.4544L8.86792 10.5877L8.07547 9.31415L5.07547 11.1808L5.86792 12.4544ZM9.25 10.8V21H10.75V10.8H9.25ZM10 20.25H6V21.75H10V20.25ZM5.75 20V12.6667H4.25V20H5.75ZM6 20.25C5.86193 20.25 5.75 20.1381 5.75 20H4.25C4.25 20.9665 5.0335 21.75 6 21.75V20.25ZM8.86792 10.5877C9.03445 10.4841 9.25 10.6039 9.25 10.8H10.75C10.75 9.42706 9.24117 8.58883 8.07547 9.31415L8.86792 10.5877ZM5.07547 11.1808C4.56211 11.5002 4.25 12.062 4.25 12.6667H5.75C5.75 12.5803 5.79459 12.5 5.86792 12.4544L5.07547 11.1808Z",
    fill: "#9DA1B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21V21.75H13.25V21H14ZM18 12.75H15V11.25H18V12.75ZM14.75 13V21H13.25V13H14.75ZM14 20.25H18V21.75H14V20.25ZM18.25 20V13H19.75V20H18.25ZM18 20.25C18.1381 20.25 18.25 20.1381 18.25 20H19.75C19.75 20.9665 18.9665 21.75 18 21.75V20.25ZM15 12.75C14.8619 12.75 14.75 12.8619 14.75 13H13.25C13.25 12.0335 14.0335 11.25 15 11.25V12.75ZM18 11.25C18.9665 11.25 19.75 12.0335 19.75 13H18.25C18.25 12.8619 18.1381 12.75 18 12.75V11.25Z",
    fill: "#9DA1B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6.75H9V5.25H15V6.75ZM8.75 7V9.97059H7.25V7H8.75ZM8 20.25H9.33333V21.75H8V20.25ZM15.25 12.1765V7H16.75V12.1765H15.25ZM9.33333 20.25H13.5V21.75H9.33333V20.25ZM9 6.75C8.86193 6.75 8.75 6.86193 8.75 7H7.25C7.25 6.0335 8.0335 5.25 9 5.25V6.75ZM15 5.25C15.9665 5.25 16.75 6.0335 16.75 7H15.25C15.25 6.86193 15.1381 6.75 15 6.75V5.25Z",
    fill: "#9DA1B5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 3C12.75 2.58579 12.4142 2.25 12 2.25C11.5858 2.25 11.25 2.58579 11.25 3H12.75ZM11.25 6C11.25 6.41421 11.5858 6.75 12 6.75C12.4142 6.75 12.75 6.41421 12.75 6H11.25ZM11.25 3V6H12.75V3H11.25Z",
    fill: "#9DA1B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuAccounts);
export default __webpack_public_path__ + "static/media/menuAccounts.3ba6acf57bb7c8aed23fb55b803374db.svg";
export { ForwardRef as ReactComponent };